import { Box, makeStyles } from "@material-ui/core";

const useSettingsRowStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    display: "grid",
    gridTemplateColumns: "1fr minmax(120px, 180px)",
    columnGap: theme.spacing(2),
    marginBottom: theme.spacing(1),
    alignItems: "start",

    [theme.breakpoints.down("xs")]: {
      gridTemplateColumns: "1fr",
      rowGap: theme.spacing(1),
    },
  },
  disabled: {
    opacity: 0.6,
  },
}));

export const SettingGridRow = ({ left, right, disabled }) => {
  const classes = useSettingsRowStyles();

  return (
    <Box className={`${classes.root} ${disabled ? classes.disabled : ""}`}>
      {left}
      {right}
    </Box>
  );
};
